import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions, wantedAction } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
} from "antd";
import axios from "axios";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import { WantedForm } from "./WantedForm";
//import { WantedTable } from "./WantedTable";
import "./Wanted.css";
import { pushNotificationService } from "../../_services/pushNotification";
import Modal from "antd/lib/modal/Modal";
import { ViewFormModel } from "./ViewForm/ViewFormModel";

const WantedTable = React.lazy(() =>
  import("./WantedTable").then((module) => ({
    default: module.WantedTable,
  }))
);

const { Option } = Select;
const FormItem = Form.Item;
let columns = [];
let data = [];
const baseUrl = `${process.env.REACT_APP_URL}/api`;
//const baseUrl = 'http://localhost:8080/api';
class Wanted extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    isCreateUserDrawerVisible: false,
    isUpdate: false,
    userFormEditData: [],
    resetFrom: false,
    userList: [],
    progress: 0,
    fileList: [],
    uploadedFileName: "",
    currentImageUrl: "",
    setCriminalViewModel: false,
    wantedTypeId: 1,
    ghunhaInfomationData: [],
  };
  userForm = React.createRef();

  componentDidMount() {
    const { user } = this.props;
    if (user && user.cityId && user) {
      this.props.dispatch(
        wantedAction.getAllWantedType(this.state.wantedTypeId, user.cityId)
      );
    }
    if (user && user.cityId && user && user.role === "4") {
      this.props.dispatch(wantedAction.getWanted());
    } else if (user && user.role === "8") {
      //this.props.dispatch(professionalAction.getAllWantedType(3));
    }
  }

  onOpenCrateUserDrawer = () => {
    this.setState({
      isCreateUserDrawerVisible: true,
      resetFrom: true,
      isUpdate: false,
    });
  };
  onCloseCrateUserDrawer = () => {
    this.setState({
      isCreateUserDrawerVisible: false,
      resetFrom: true,
      isUpdate: false,
    });
  };

  onCityChange = (cityId, form) => {
    if (cityId) {
      this.props.dispatch(professionalAction.getDistrict(cityId, form));
    }
  };
  onGhunhaCityChange = (cityId, form) => {
    if (cityId) {
      this.props.dispatch(professionalAction.getDistrict(cityId, form));
    }
  };

  onKaydaChange = (actId) => {
    if (actId) {
      this.props.dispatch(professionalAction.getKalam(actId));
    }
  };

  onNewsStatusChange = (values, flag) => {
    const { user } = this.props;
    if (values) {
      let updateObj = {
        status: flag,
      };
      this.props.dispatch(wantedAction.updateWantedType(values.id, updateObj));
      message.success("Update the Perticular status !!!");
      this.props.dispatch(wantedAction.getAllWantedType(1, user.cityId));
    }
  };

  getDistrictName = (id) => {
    const { gunhaDistricts } = this.props && this.props.professionals;
    //console.log("gunhaDistricts",gunhaDistricts);
    if (gunhaDistricts && gunhaDistricts.length) {
      return (
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  onFormFinish = async (values) => {
    const { user, users, professionals } = this.props;
    if (values.newsType == 10) {
      let obj = {
        wantedid: values.newsType,
        wantedType: this.getWantedName(values.newsType),
        license_no: values.license_number,
        owner_name: values.owner_name,
        address: values.address,
        city: user && user.cityId,
        districtName: this.getCityName(user && user.cityId),
        status: 1,
        userId: user && user.id,
        createdby: user && user.id,
        createdAt: new Date(),
        updatedAt: new Date(),
      };
      this.props.dispatch(wantedAction.createLicenseNumber(obj));
      this.setState((prevState) => ({
        isCreateUserDrawerVisible: false,
        resetFrom: true,
      }));
      message.success("License Number save Successfully !!!");
      this.props.dispatch(
        wantedAction.getAllWantedType(values.newsType, user.cityId)
      );
    } else if (values.newsType == 8 || values.newsType == 9) {
      if (values.files && values.files.file && values.files.file.name) {
        this.uploadVehicleImage(values);
      } else {
        let obj = {
          wantedid: values.newsType,
          wantedType: this.getWantedName(values.newsType),
          vehical_no: values.vehical_no,
          model: values.model,
          colour: values.colour,
          chassis_no: values.chassis_no,
          city: user && user.cityId,
          districtName: this.getCityName(user && user.cityId),
          status: 1,
          userId: user && user.id,
          createdby: user && user.id,
          createdAt: new Date(),
          updatedAt: new Date(),
        };
        this.props.dispatch(wantedAction.createVehicle(obj));
        this.setState((prevState) => ({
          isCreateUserDrawerVisible: false,
          resetFrom: true,
        }));
        message.success("Vehicle info save Successfully !!!");
        this.props.dispatch(
          wantedAction.getAllWantedType(values.newsType, user.cityId)
        );
      }
    } else if (
      values.newsType == 11 ||
      values.newsType == 12 ||
      values.newsType == 13
    ) {
      let obj = {
        wantedid: values.newsType,
        wantedType: this.getWantedName(values.newsType),
        mobile_no: values.mobile_no,
        imei_no: values.imei_no,
        model: values.model,
        colour: values.colour,
        city: user && user.cityId,
        districtName: this.getCityName(user && user.cityId),
        status: 1,
        userId: user && user.id,
        createdby: user && user.id,
        createdAt: new Date(),
        updatedAt: new Date(),
      };
      this.props.dispatch(wantedAction.createMobile(obj));
      this.setState((prevState) => ({
        isCreateUserDrawerVisible: false,
        resetFrom: true,
      }));
      message.success("Mobile Info save Successfully !!!");
      this.props.dispatch(
        wantedAction.getAllWantedType(values.newsType, user.cityId)
      );
    } else {
      if (values.files && values.files.file && values.files.file.name) {
        this.uploadImage(values);
      } else {
        let obj = {
          wantedInformation: {
            address: values.address,
            wantedid: values.newsType ? values.newsType : 1,
            wantedType: values.newsType ? values.newsType : 1,
            address: values.address,
            fullName: values.name,
            state: values.state,
            city: user && user.cityId,
            cityId: values.city,
            cityName: values.cityName,
            district: values.districtName,
            districtName: values.district,
            tadipar_area: values.tadipar_area,
            status: 1,
            userId: user && user.id,
            createdby: user && user.id,
            createdAt: new Date(),
            role: user && user.role,
            updatedAt: new Date(),
          },
          kkinfo: values.membersList,
        };
        //console.log("wanted OBJ", obj);
        this.props.dispatch(wantedAction.createWantedType(obj));
        this.setState((prevState) => ({
          isCreateUserDrawerVisible: false,
          resetFrom: true,
        }));
        message.success("Perticular save Successfully !!!");
        this.props.dispatch(
          wantedAction.getAllWantedType(
            values.newsType ? values.newsType : 1,
            user.cityId
          )
        );
      }
    }
  };

  onFormUpdate = (values) => {
    const { id } = this.state.userFormEditData;
    this.props.dispatch(userActions.updateUser(values, id));
    this.setState((prevState) => ({
      isCreateUserDrawerVisible: false,
      isUpdate: false,
    }));
  };

  getWantedName = (id) => {
    const { pc_wanted_type } = this.props && this.props.getWanted;
    if (pc_wanted_type && pc_wanted_type.length) {
      return (
        _.filter(pc_wanted_type, function (o) {
          return o.id === id;
        }) &&
        _.filter(pc_wanted_type, function (o) {
          return o.id === id;
        }).name
      );
    }
  };

  onEdituser = (data) => {
    this.setState((prevState) => ({
      isCreateUserDrawerVisible: true,
      isUpdate: true,
      userFormEditData: data,
    }));
  };

  onUserFormSave = () => {
    this.userForm.current.onFinish(true);
  };
  onUserFormUpdate = () => {
    this.userForm.current.onFinish(false);
  };

  getDateFormatYear = (value) => {
    if (value) {
      return moment(value).format("YYYY");
    }
  };

  uploadImage = async (options) => {
    const { onSuccess, onError, files, onProgress } = options;
    const { user } = this.props;
    const appendType = "profileImage";
    const imageUploadUrl = "/imageupload/profile-img-upload";

    const fmData = new FormData();
    // this.setProgress(0);
    this.setState({
      progress: 0,
    });
    const config = {
      headers: {
        accept: "application/json",
        "Accept-Language": "en-US,en;q=0.8",
        "Content-Type": `multipart/form-data; boundary=${fmData._boundary}`,
      },
    };

    const newFileName = "w_" + files.file.name;
    fmData.append(
      appendType,
      files && files.file.originFileObj,
      files && files.file && newFileName,
      files.file
    );
    try {
      const res = await axios.post(baseUrl + imageUploadUrl, fmData, config);

      //console.log("fmData", fmData);

      if (res.data && res.data.error) {
        message.error("something went wrong !!!");
      }
      if (res.data) {
        let obj = {
          wantedInformation: {
            uploadedFileName: files.file ? res.data.imageName : "",
            uploadedFileUrl: files.file ? res.data.imageLocation : "",
            address: options.address,
            wantedid: options.newsType ? options.newsType : 1,
            wantedType: options.newsType ? options.newsType : 1,
            address: options.address,
            fullName: options.name,
            state: options.state,
            city: user && user.cityId,
            cityId: options.city,
            cityName: options.cityName,
            district: "",
            districtName: options.district,
            tadipar_area: options.tadipar_area,
            status: 1,
            userId: user && user.id,
            createdby: user && user.id,
            createdAt: new Date(),
            role: user && user.role,
            updatedAt: new Date(),
          },
          kkinfo: options.membersList,
        };
        this.props.dispatch(wantedAction.createWantedType(obj));
        this.setState((prevState) => ({
          isCreateUserDrawerVisible: false,
          resetFrom: true,
          currentImageUrl: obj.uploadedFileUrl,
        }));
        message.success("Perticular save Successfully !!!");
        this.props.dispatch(
          wantedAction.getAllWantedType(
            options.newsType ? options.newsType : 1,
            user.cityId
          )
        );
      }
    } catch (err) {
      // const error = new Error("Some error");
      // onError({ err });
      message.error("something went wrong !!");
    }
  };

  /** for upload mobile image */
  uploadVehicleImage = async (options) => {
    const { onSuccess, onError, files, onProgress } = options;
    const { user } = this.props;
    const appendType = "profileImage";
    const imageUploadUrl = "/imageupload/profile-img-upload";

    const fmData = new FormData();
    // this.setProgress(0);
    this.setState({
      progress: 0,
    });
    const config = {
      headers: {
        accept: "application/json",
        "Accept-Language": "en-US,en;q=0.8",
        "Content-Type": `multipart/form-data; boundary=${fmData._boundary}`,
      },
    };
    const newFileName = "w_" + files.file.name;
    fmData.append(
      appendType,
      files && files.file.originFileObj,
      files && files.file && newFileName
    );
    try {
      const res = await axios.post(baseUrl + imageUploadUrl, fmData, config);

      if (res.data && res.data.error) {
        message.error("something went wrong !!!");
      }
      if (res.data) {
        let obj = {
          uploadedFileName: files.file ? res.data.imageName : "",
          uploadedFileUrl: files.file ? res.data.imageLocation : "",
          wantedid: options.newsType,
          wantedType: this.getWantedName(options.newsType),
          vehical_no: options.vehical_no,
          model: options.model,
          colour: options.colour,
          chassis_no: options.chassis_no,
          city: user && user.cityId,
          districtName: this.getCityName(user && user.cityId),
          status: 1,
          userId: user && user.id,
          createdby: user && user.id,
          createdAt: new Date(),
          updatedAt: new Date(),
        };
        this.props.dispatch(wantedAction.createVehicle(obj));
        this.setState((prevState) => ({
          isCreateUserDrawerVisible: false,
          resetFrom: true,
          currentImageUrl: obj.uploadedFileUrl,
        }));
        message.success("Vehicle info save Successfully !!!");
        this.props.dispatch(
          wantedAction.getAllWantedType(options.newsType, user.cityId)
        );
      }
    } catch (err) {
      // const error = new Error("Some error");
      // onError({ err });
      message.error("something went wrong !!");
    }
  };

  onWantedTypeChange = (selectedWanted) => {
    const { user } = this.props;
    if (selectedWanted) {
      this.setState({
        tableLoading: true,
        wantedTypeId: selectedWanted,
      });
      this.props.dispatch(
        wantedAction.getAllWantedType(selectedWanted, user.cityId)
      );
    }
  };

  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      this.props.dispatch(wantedAction.getWantedTypeViewsById(data));
    }
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };
  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { wantedType } = this.props;
    let pc_wanted_type = this.props.getWanted;
    const requiredKeys = [];
    if (wantedType && wantedType.length && wantedType.length > 0) {
      let columns1 =
        wantedType &&
        wantedType.length &&
        wantedType.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
            SrNo: index + 1,
          };
        });

      let tablelabes = columns1 && Object.keys(columns1[0]);

      let tableColumns = [];
      tableColumns && tableColumns.unshift("SrNo");
      tablelabes.forEach((item) => {
        if (
          _.filter(requiredKeys, function (o) {
            return o === item;
          }).length
        ) {
          tableColumns.push(item);
        }
      });

      let columnList = tableColumns.map((item) => {
        return {
          title: item,
          dataIndex: item,
          key: item,
        };
      });
      // columns1.reverse();
      data = columns1;
      columns = columnList;
    } else {
      data = [];
    }
    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            ghost={false}
            onBack={false}
            title={user && user.userid}
            subTitle={
              user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
            }
            extra={[
              <Button
                type="primary"
                className="mb-4"
                onClick={this.onOpenCrateUserDrawer}
              >
                नवीन जोडा
              </Button>,
            ]}
          >
            <Descriptions size="small" column={3}>
              <Descriptions.Item
                label={user && user.role === "8" ? "State Name" : "City Name"}
              >
                {user && user.role === "8"
                  ? "महाराष्ट्र"
                  : "महाराष्ट्र" +
                    " " +
                    "( " +
                    this.getCityName(user && user.cityId) +
                    " )"}
              </Descriptions.Item>
              <Descriptions.Item label=""></Descriptions.Item>
            </Descriptions>

            <Descriptions size="small" column={3}>
              <Descriptions.Item>
                <Form.Item
                  name="wantedSelection"
                  label="Perticular"
                  style={{ width: "30%" }}
                >
                  <Select
                    style={{ width: "100%" }}
                    onChange={this.onWantedTypeChange}
                    defaultValue={["Wanted"]}
                  >
                    {pc_wanted_type &&
                      pc_wanted_type.length &&
                      pc_wanted_type.map((res, index) => (
                        <Option key={index} value={res.id}>
                          {res.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Descriptions.Item>
            </Descriptions>
          </PageHeader>
        </div>

        <Divider />
        <Drawer
          title="पाहिजे/फरार/तडीपार आरोपी ची माहिती"
          placement="right"
          width={720}
          closable={true}
          onClose={this.onCloseCrateUserDrawer}
          visible={this.state.isCreateUserDrawerVisible}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={this.onCloseCrateUserDrawer}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              {!this.state.isUpdate ? (
                <Button onClick={this.onUserFormSave} type="primary">
                  Save
                </Button>
              ) : (
                <Button onClick={this.onUserFormUpdate} type="primary">
                  Update
                </Button>
              )}
            </div>
          }
        >
          <WantedForm
            ref={this.userForm}
            user={user}
            isUpdate={this.state.isUpdate}
            users={users}
            dataStates={this.props.professionals}
            dataWantedType={this.props.getWanted}
            onFormFinish={this.onFormFinish}
            onFormUpdate={this.onFormUpdate}
            userFormEditData={this.state.userFormEditData}
            resetFrom={this.state.resetFrom}
            onCityChange={this.onCityChange}
            onGhunhaCityChange={this.onGhunhaCityChange}
            onKaydaChange={this.onKaydaChange}
          ></WantedForm>
        </Drawer>

        <Modal
          title="Wanted View"
          top
          visible={this.state.setCriminalViewModel}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
        >
          <ViewFormModel
            key={1}
            dataStates={this.props.professionals}
            viewList={this.props.wantedViewList}
          ></ViewFormModel>
        </Modal>

        <React.Suspense fallback={<div>Loading...</div>}>
          <WantedTable
            onEdituser={this.onEdituser}
            onViewAccusedForm={this.onViewAccusedForm}
            onNewsStatusChange={this.onNewsStatusChange}
            data={data}
            columns={columns}
            userRole={user}
            wantedTypeId={this.state.wantedTypeId}
          ></WantedTable>
        </React.Suspense>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals, wanted } = state;
  const { user } = authentication;
  const { wantedType, getWanted, wantedViewList } = wanted;
  return {
    user,
    users,
    wantedType,
    professionals,
    getWanted,
    wantedViewList,
  };
}

const connectedWanted = connect(mapStateToProps)(Wanted);
export { connectedWanted as Wanted };
